import { ManageTable, type ManageField } from '@/components/ManageTable'
import { Input } from '@/components/ui/input'
import { usePersistentState } from '@/hooks/usePersistentState'

export default function Device() {
  const [filters, setFilter, clearFilters] = usePersistentState<Record<string, any>>(
    'admin:device:filters',
    {},
  )

  const handleResetFilters = () => {
    clearFilters()
  }

  const fields: ManageField[] = [
    {
      desc: 'device_id',
      field: 'device_id',
    },
    {
      desc: 'BRAND',
      field: 'BRAND',
    },
    {
      desc: 'HARDWARE',
      field: 'HARDWARE',
    },
    {
      desc: 'MODEL',
      field: 'MODEL',
    },
    {
      desc: 'DEVICE',
      field: 'DEVICE',
    },
    {
      desc: 'use',
      field: 'use',
    },
    {
      desc: '更新日期',
      field: 'update_time',
    },
  ]

  const filterUI = (
    <Input
      placeholder="输入 device_id"
      className="w-[200px]"
      value={filters.device_id || ''}
      onChange={(e) => {
        if (e.target.value) {
          setFilter({ device_id: e.target.value })
        } else {
          setFilter({})
        }
      }}
    />
  )

  return (
    <div className="h-full p-6 overflow-auto">
      <h1 className="text-2xl font-bold mb-6">设备管理</h1>
      <ManageTable fields={fields} collect="deviceInfo" filters={filters} filter={filterUI} onResetFilters={handleResetFilters} />
    </div>
  )
}
